import { createSlice } from "@reduxjs/toolkit";
import { AllQuestionCaseInsensitive } from "../types/question-type";

export interface QuestionMapping {
  [id: string]: AllQuestionCaseInsensitive;
}

interface INIT_STATE {
  selectedId: string;
  DataMapping: QuestionMapping;
}

const INIT_STATE: INIT_STATE = {
  selectedId: "",
  DataMapping: {}
};

const QuestionPreviewSlice = createSlice({
  name: "QuestionPreviewSlice",
  initialState: INIT_STATE,
  reducers: {
    resetPreviewData() {
      return INIT_STATE;
    },
    setIdDataMapping(state, action) {
      const [[id, _]] = Object.entries(action.payload);
      state.selectedId = id;
      state.DataMapping = {
        ...state.DataMapping,
        ...action.payload
      };
    },
    updateQuestionPreviewData(state, action) {
      const [[id, data]] = Object.entries(action.payload) as [
        string,
        AllQuestionCaseInsensitive
      ][];

      state.DataMapping = {
        ...state.DataMapping,
        [id]: {
          ...state.DataMapping[id],
          ...data
        }
      };
    }
  }
});

export default QuestionPreviewSlice;

export const QuestionPreviewSliceActions = QuestionPreviewSlice.actions;
